import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-carosserie-auto',
  templateUrl: './detail-carosserie-auto.component.html',
  styleUrls: ['./detail-carosserie-auto.component.scss']
})
export class DetailCarosserieAutoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
